import { css } from "lit";

export const feedbackLabelStyles = css`
  .feedback {
    position: fixed;
    bottom: 278px;
    right: 15px;
    transform: rotate(-90deg);
    transform-origin: 100%;
    box-shadow: 0 0 20px rgb(0 0 0 / 0.2);
    transition: all 0.2s ease-in-out;
    z-index: 100;
  }

  .feedback.preview-mode {
    pointer-events: none;
    opacity: 0.6;
  }
`;
